import type { DocumentStraighteningParameters, ImageInput, Point } from '../types';
import { DocumentStraighteningResult, handleImageInput, withSBErrorHandling } from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotDocumentEnhancerImpl = {
  async straightenImage(params: {
    image: ImageInput;
    straighteningParameters: DocumentStraighteningParameters;
    priorCornersNormalized?: Point[];
  }): Promise<DocumentStraighteningResult> {
    return withSBErrorHandling(
      async () =>
        new DocumentStraighteningResult(
          await ScanbotSDKPlugin.straightenDocumentImage({
            ...params,
            image: handleImageInput(params.image),
          }),
        ),
    );
  },
};
